import 'css-chunksrc/client/common/treeToggle/controls/openLast/styles.scss';export default {
  "openLast": "_openLast_3om4e_1",
  "disabled": "_disabled_3om4e_10",
  "toggleArrow": "_toggleArrow_3om4e_14"
};